import actions from "./actions";

const initState = {
  //Add Recharge Plan
  rechargeButtonLoading: false,
  rechargePlanMessage: null,
  rechargePlanError: null,
  rechargePlanFormModal: false,
  // Get Recharge Plan
  getRechargePlanResult: [],
  getRechargePlanLoading: false,
  getRechargePlanError: null,
  getRechargePlanMessage: null,

  //Delete Recharge Plan
  deleteLoading: false,
  deletePlanMessage: null,
  deletePlanError: null,
  deleteButtonLoading: false,
  deletePlanFormModal: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.ADD_CHATR_RECHARGE_PLAN:
      return {
        ...state,
        rechargeButtonLoading: true,
        rechargePlanMessage: null,
        rechargePlanError: null,
        rechargePlanFormModal: true,
      };
    case actions.ADD_CHATR_RECHARGE_PLAN_SUCCESS:
      return {
        ...state,
        rechargeButtonLoading: false,
        rechargePlanError: null,
        rechargePlanMessage: action.rechargeMessage,
        getRechargePlanResult: action.rechargeResult,
        rechargePlanFormModal: false,
      };
    case actions.ADD_CHATR_RECHARGE_PLAN_FAILED:
      return {
        ...state,
        rechargeButtonLoading: false,
        rechargePlanError: action.rechargeError,
        rechargePlanMessage: null,
        rechargePlanFormModal: true,
      };

    case actions.GET_CHATR_RECHARGE_PLAN_DATA:
      return {
        ...state,
        getRechargePlanLoading: true,
        getRechargePlanError: null,
        getRechargePlanMessage: null,
        getRechargeButtonloading: true,
        getRechargePlanFormModal: false,
      };
    case actions.GET_CHATR_RECHARGE_PLAN_DATA_SUCCESS:
      return {
        ...state,
        getRechargePlanLoading: false,
        getRechargePlanError: null,
        getRechargeButtonloading: false,
        getRechargePlanResult: action.rechargePlanData,
      };
    case actions.GET_CHATR_RECHARGE_PLAN_DATA_FAILED:
      return {
        ...state,
        getRechargePlanLoading: false,
        getRechargePlanError: action.rechargePlanError,
        getRechargePlanMessage: null,
        getRechargeButtonloading: false,
        getRechargePlanFormModal: false,
      };

    case actions.DELETE_CHATR_RECHARGE_PLAN:
      return {
        ...state,
        deleteLoading: false,
        deletePlanMessage: null,
        deletePlanError: null,
        deleteButtonLoading: true,
        deletePlanFormModal: false,
      };
    case actions.DELETE_CHATR_RECHARGE_PLAN_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deletePlanMessage: action.deleteChatrRechargeMessage,
        getRechargePlanResult: action.deleteChatrRechargeResult,
        deletePlanError: null,
        deleteButtonLoading: false,
        deletePlanFormModal: false,
      };

    case actions.PREPARE_RECHARGE_PLAN_FORM:
      return {
        ...state,
        rechargePlanFormModal: true,
      };

    case actions.RESET_CHATR_RECHARGE_PLAN:
      return {
        ...state,
        rechargeButtonLoading: false,
        rechargePlanMessage: null,
        rechargePlanError: null,
        rechargePlanFormModal: false,
        getRechargePlanError: null,
        getRechargePlanMessage: null,
      };
    case actions.RESET_CHATR_RECHARGE_PLAN_MESSAGE:
      return {
        ...state,
        rechargePlanMessage: null,
        rechargePlanError: null,
        deletePlanMessage: null,
        deletePlanError: null,
      };
    default:
      return state;
  }
}
